import React from 'react';
import { content } from '../content/content';
import { ContentType } from '../content/content';

const isDev = process.env.NODE_ENV === 'development';

export const pollStatus = ({
  endpoint,
  setAsReady,
  setStatusText,
  pollingInterval,
  contentType,
}: {
  endpoint: string;
  setAsReady: () => void;
  setStatusText: (value: string) => void;
  pollingInterval: number;
  contentType: ContentType;
}) => {
  let timeoutObj: number;
  let mounted = true;

  const fetcher = (contentType: ContentType) => {
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        if (!mounted) return;
        // TODO Temporary status check. Replace once endpoint is ready
        if (data.status === 'Ready') {
          setAsReady();
        }
      })
      .catch((err) => {
        if (isDev || !mounted) return;
        setStatusText(content[contentType].status.ERROR.text);
      })
      .finally(() => {
        if (!mounted) return;
        // setTimeout's type is different in Node.js and browser, so we cast it to number
        timeoutObj = setTimeout(() => fetcher(contentType), pollingInterval) as unknown as number;
      });
  };
  fetcher(contentType);
  return () => {
    mounted = false;
    clearTimeout(timeoutObj);
  };
};
